import { useState } from "react";

import api from "../../api";

export default function ForgotPasswordForm({ switchTab }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleReset = async () => {
    setLoading(true);
    setMessage("");
    setError("");

    try {
      await api.post(
        "/api/auth/password/reset",
        {
          email,
        }
      );

      setMessage(
        "Password reset email sent successfully. Please check your inbox."
      );
    } catch (err) {
      setError(
        err.response?.data?.detail ||
          "Failed to send reset email. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col justify-center items-center h-full text-center space-y-6">

      <p className="text-[#756556] text-sm max-w-sm leading-6">
        Enter your email address and we’ll send you a link to reset your
        password.
      </p>

      <input
        type="email"
        placeholder="Email address"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="
          w-80
          border
          border-[#D8CBB8]
          rounded-lg
          px-4
          py-3
          bg-[#FFFDF8]
          text-[#2F241D]
          placeholder:text-[#9A8F82]
          focus:outline-none
          focus:border-[#0F766E]
          focus:ring-1
          focus:ring-[#0F766E]
          transition
        "
      />

      <button
        type="button"
        onClick={handleReset}
        disabled={loading}
        className="
          w-80
          bg-[#0F766E]
          text-white
          py-3
          rounded-lg
          font-medium
          hover:bg-[#0B5F59]
          disabled:opacity-70
          disabled:cursor-not-allowed
          transition
        "
      >
        {loading ? "Sending..." : "Send Reset Link"}
      </button>

      {message && (
        <p className="w-80 text-[#0F766E] text-sm bg-[#E6F3F1] rounded-lg px-4 py-3">
          {message}
        </p>
      )}

      {error && (
        <p className="w-80 text-red-600 text-sm bg-red-50 rounded-lg px-4 py-3">
          {error}
        </p>
      )}

      <p className="text-sm text-[#756556]">
        No account?{" "}
        <button
          type="button"
          onClick={() => switchTab("register")}
          className="
            text-[#0F766E]
            font-semibold
            hover:text-[#0B5F59]
            hover:underline
            transition
          "
        >
          Register now
        </button>
      </p>
    </div>
  );
}